angular.module('picmonicng').directive('picmonicsSidescroll', [
  '$filter',
  '$timeout',
  '$window',
  function ($filter, $timeout, $window) {
    return {
      scope: {
        promise: '=',
      },
      transclude: true,
      templateUrl: '/templates/directives/picmonics-sidescroll.html',
      link: function (scope, element, attrs) {
        scope.scrollLeft = function () {
          element.find('.sidescroll-wrapper').animate({ scrollLeft: '-=' + scope.scrollIntervalWidth }, 'fast');
        };

        scope.scrollRight = function () {
          element.find('.sidescroll-wrapper').animate({ scrollLeft: '+=' + scope.scrollIntervalWidth }, 'fast');
        };

        function determineShadows() {
          scope.contentWidth = 0;
          scope.contentHeight = attrs.initialHeight ? parseInt(attrs.initialHeight, 10) : 0;
          scope.scrollIntervalWidth = 0;

          var picmonicsWrapper = element.find('.sidescroll-content-wrapper');
          picmonicsWrapper.css('visibility', 'visible');

          picmonicsWrapper.children().each(function () {
            var child = angular.element(this);
            scope.contentWidth += child.outerWidth(true);

            if (!scope.scrollIntervalWidth) {
              scope.scrollIntervalWidth = child.outerWidth(true);
            }

            if (child.outerHeight(true) > scope.contentHeight) {
              scope.contentHeight = child.outerHeight(true);
            }
          });

          if (picmonicsWrapper.position().left < 0) {
            scope.leftShadow = true;
          } else {
            scope.leftShadow = false;
          }

          if (scope.contentWidth + picmonicsWrapper.position().left > element.find('.sidescroll-wrapper').width()) {
            scope.rightShadow = true;
          } else {
            scope.rightShadow = false;
          }
        }

        element.find('.sidescroll-wrapper').on('scroll', function () {
          determineShadows();
          scope.$apply();
        });

        angular.element($window).bind('resize', function () {
          determineShadows();
          scope.$apply();
        });

        scope.$watch(
          function () {
            return scope.promise;
          },
          function (promise) {
            if (promise) {
              promise.$promise.then(function () {
                $timeout(function () {
                  determineShadows();
                }, 200);
              });
            }
          }
        );
      },
    };
  },
]);
